var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFemaleEmployee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-female 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.507 25.664L27.959 21.604L24.327 19.896C24.327 19.824 24.399 19.788 24.539 19.788L24.647 19.68H29.347C30.271 19.68 30.735 19.252 30.735 18.396V14.872H30.627C30.483 9.88402 29.023 5.93202 26.247 3.01202C24.751 1.37202 23.079 0.41202 21.227 0.12802H20.803L20.695 0.0200195H19.415L19.199 0.12802H18.771C16.919 0.41202 15.279 1.33602 13.855 2.90402C11.007 5.89602 9.51103 9.88402 9.36703 14.872V18.396C9.36703 19.252 9.79503 19.68 10.651 19.68H15.459L15.671 19.892C15.743 19.964 15.815 20 15.883 20L12.359 21.604L3.49103 25.664C2.63503 26.02 2.20703 26.768 2.20703 27.908V37.632C2.20703 38.272 2.40303 38.824 2.79503 39.288C3.18703 39.752 3.66703 39.984 4.23903 39.984H35.759C36.327 39.984 36.811 39.752 37.203 39.288C37.595 38.824 37.791 38.272 37.791 37.632V27.908C37.787 26.768 37.363 26.02 36.507 25.664Z",
    fill: "#FB6CA7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleEmployee);
export default __webpack_public_path__ + "static/media/Female Employee.f20fc54ca8b47af23d626e54e051cca1.svg";
export { ForwardRef as ReactComponent };